export default "__VITE_ASSET__D6JBUz9Z__";